// extracted by mini-css-extract-plugin
export default {"startGameButton":"StartGameButton_startGameButton__Q6T3X","noPermissionTooltip":"StartGameButton_noPermissionTooltip__mI9Ut"};